import React, { useState } from 'react';
import Dialog from '../../Dialog';
import Select from '../../Inputs/Select';
import { FullSizeColumn } from '../../FlexBox';
import DetailsContent from './DetailsContent';

const MessageFeedbackDialog = function MessageFeedbackDialog({
  open,
  onClose,
  onSubmit = () => {},
  activityTypeName = 'SMS',
  detailsData = null,
  activityOutcomes = {},
}) {
  const [value, setValue] = useState('');

  return (
    <Dialog
      id="message-feedback-dialog"
      open={open}
      onClose={onClose}
      title={detailsData ? 'DETAILS' : 'MESSAGE_FEEDBACK'}
      width="sm"
      onSubmit={detailsData ? undefined : () => onSubmit(value)}
      fullWidth
      dividers={!detailsData}
    >
      {detailsData ? (
        <DetailsContent {...detailsData} />
      ) : (
        <FullSizeColumn padding="16px" minHeight="100px">
          <Select
            name="feedback"
            label="MESSAGE_FEEDBACK"
            options={(activityOutcomes[activityTypeName] || []).map(
              ({ id, name }) => ({ label: name, value: id })
            )}
            value={value}
            onChange={setValue}
            required
          />
        </FullSizeColumn>
      )}
    </Dialog>
  );
};

export default MessageFeedbackDialog;
